import React from 'react';
import { Loader } from 'components';
import { Redirect } from 'react-router';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';

const AccountConfirmationContainer = ({
    token, checkAccountConfirmationToken, auth,
}: Props) => {
    if (auth && auth.auth && auth.auth.profile) return <Redirect to="/" />;

    const [step, setStep] = React.useState(1);
    const [password, setPassword] = React.useState('');
    const [verificationCode, setVerificationCode] = React.useState('');
    const [tokenProcessing, setTokenProcessing] = React.useState(true);

    React.useEffect(() => {
        const checkToken = async () => {
            setTokenProcessing(true);
            await checkAccountConfirmationToken({ token });
            setTokenProcessing(false);
        };

        checkToken();
    }, []);

    if (tokenProcessing) {
        return <Loader />;
    }

    return (
        <>
            {step === 1 && (
                <Step1
                    expertData={auth && auth.expertConfirmationData}
                    nextStep={(pass: string) => { setPassword(pass); setVerificationCode('0000'); setStep(2); }}
                    token={token}
                />
            )}
            {step === 2 && (
                //     <Step2
                //       nextStep={(code: string) => { setVerificationCode(code); setStep(3); }}
                //       prevStep={() => setStep(1)}
                //       phone={auth && auth.expertConfirmationData ? auth.expertConfirmationData.phone : ''}
                //     />
                // )}
                // {step === 3 && (
                <Step3
                    email={auth && auth.expertConfirmationData ? auth.expertConfirmationData.email : ''}
                    password={password}
                    verificationCode={verificationCode}
                    token={token}
                />
            )}
        </>
    );
};

const mapState = (state: IRootState) => ({
    apiError: state.errors.error,
    auth: state.auth,
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    checkAccountConfirmationToken: dispatch.auth.checkAccountConfirmationTokenAsync,
    confirmAccount: dispatch.auth.confirmAccountAsync,
});

export default connect(mapState, mapDispatch)(AccountConfirmationContainer);

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>
type Props = connectedProps & IProps;

interface IProps {
    token: string;
}
